import { useState } from "react";
import { SlidersHorizontal } from "lucide-react";

export default function MobileFilterPanel({ children, className = "", testId, buttonLabel = "Filters" }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="mobile-filter-toggle mb-3 items-center gap-2 border border-gray-300 bg-white px-3 py-2 text-xs font-mono font-bold uppercase tracking-wider"
        aria-expanded={open}
      >
        <SlidersHorizontal size={14} />
        {open ? "Hide filters" : buttonLabel}
      </button>
      <div data-testid={testId} className={`mobile-filter-panel ${open ? "is-open" : ""} ${className}`}>
        {children}
      </div>
    </>
  );
}
